import { useLingui } from '@lingui/react/macro'
import { ToggleRadioGroup, ToggleRadioItem } from 'features/navbar/sharedStyles'
import { useKeyboardShortcuts } from 'features/settings/KeyboardShortcutsProvider'
import React from 'react'
import styled from 'styled-components'

const StyledContainer = styled.div`
  padding: 0.5rem 1rem;
  width: 100%;
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: center;
  line-height: 1.25;
`

/**
 * Toggle in the account menu for enabling/disabling keyboard shortcuts.
 * Persisted to localStorage via KeyboardShortcutsProvider.
 */
export const KeyboardShortcutsToggle: React.FC = () => {
  const { keyboardShortcutsEnabled, setKeyboardShortcutsEnabled } =
    useKeyboardShortcuts()
  const { t } = useLingui()
  const labelId = React.useId()

  return (
    <StyledContainer>
      <span id={labelId}>{t`Keyboard Shortcuts`}</span>
      <ToggleRadioGroup
        role='group'
        aria-labelledby={labelId}
        value={keyboardShortcutsEnabled ? 'on' : 'off'}
        onValueChange={(value) => setKeyboardShortcutsEnabled(value === 'on')}>
        <ToggleRadioItem
          value='off'
          aria-label={t`Turn keyboard shortcuts off`}
          onSelect={(event) => event.preventDefault()}>
          {t`Off`}
        </ToggleRadioItem>
        <ToggleRadioItem
          value='on'
          aria-label={t`Turn keyboard shortcuts on`}
          onSelect={(event) => event.preventDefault()}>
          {t`On`}
        </ToggleRadioItem>
      </ToggleRadioGroup>
    </StyledContainer>
  )
}
